/**
 * Feature Cards Module
 * Obsługuje interaktywne karty na stronach produktowych:
 * - Like button (polubienia z localStorage)
 * - Flip cards (animacja 3D)
 * - Video autoplay (IntersectionObserver, jedno wideo naraz)
 */

(function () {
  'use strict';

  // ============================================
  // SELECTORS
  // ============================================
  const SELECTORS = {
    card: '.feature-card',
    flippable: '.feature-card--flippable',
    flipTrigger: '.feature-card__flip-trigger',
    likeBtn: '.like-btn',
    video: '.feature-card--video',
    videoElement: '.feature-card__video',
    ownItSwitch: '.own-it-switch',
    ownItCard: '.feature-card--own-it',
    ownItVideo: '.feature-card__own-it-video'
  };

  const CLASSES = {
    flipped: 'is-flipped',
    visible: 'is-visible',
    ownItActive: 'is-own-it-active'
  };


  // ============================================
  // FLIP FUNCTIONALITY
  // ============================================
  function initFlipCards() {
    const flippableCards = document.querySelectorAll(SELECTORS.flippable);

    if (!flippableCards.length) return;

    flippableCards.forEach(function (card) {
      // Kliknięcie w trigger (ikona play w rogu)
      const trigger = card.querySelector(SELECTORS.flipTrigger);

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleFlip(card);
        });
      }

      // Zatrzymaj propagację kliknięcia w .btn (np. easter-egg), nie triggeruje flipa
      var btns = card.querySelectorAll('.btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      // Kliknięcie w kartę (ale nie w like button ani .btn)
      card.addEventListener('click', function (e) {
        // Sprawdź czy klik nie był w like button lub .btn
        if (e.target.closest(SELECTORS.likeBtn)) return;
        if (e.target.closest(SELECTORS.flipTrigger)) return;
        if (e.target.closest('.btn')) return;

        toggleFlip(card);
      });
    });
  }

  function toggleFlip(card) {
    card.classList.toggle(CLASSES.flipped);
  }

  // ============================================
  // VIDEO AUTOPLAY FUNCTIONALITY
  // Każde wideo gra gdy jest widoczne (nawet fragment),
  // wszystkie widoczne wideo odtwarzają się równocześnie.
  // ============================================
  function initVideoAutoplay() {
    const videos = document.querySelectorAll(SELECTORS.videoElement);

    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: odtwórz wszystkie od razu
      videos.forEach(function (video) {
        video.play().catch(function () { });
      });
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0 // graj przy jakimkolwiek fragmencie widoczności
    };

    const videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {
            // Autoplay zablokowany przez przeglądarkę
          });
        } else {
          video.pause();
        }
      });
    }, observerOptions);

    // Obserwuj każdy element <video> bezpośrednio
    videos.forEach(function (video) {
      videoObserver.observe(video);
    });
  }

  // ============================================
  // CARD VISIBILITY (animacja tekstu przy wejściu do viewport)
  // ============================================
  function initCardVisibility() {
    const animatedCards = document.querySelectorAll(
      '.feature-card--image, .feature-card--image-title'
    );

    if (!animatedCards.length) return;

    // Sprawdź czy IntersectionObserver jest dostępny
    if (!('IntersectionObserver' in window)) {
      // Fallback: pokaż wszystkie od razu
      animatedCards.forEach(function (card) {
        card.classList.add(CLASSES.visible);
      });
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2 // 20% karty widoczne
    };

    const visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(CLASSES.visible);
          // Przestań obserwować po dodaniu klasy (animacja jednorazowa)
          visibilityObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedCards.forEach(function (card) {
      visibilityObserver.observe(card);
    });
  }

  // ============================================
  // OWN IT SWITCH — toggle obraz ↔ wideo
  // ============================================
  function initOwnItSwitch() {
    var switches = document.querySelectorAll(SELECTORS.ownItSwitch);

    if (!switches.length) return;

    switches.forEach(function (switchBtn) {
      switchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var card = switchBtn.closest(SELECTORS.card);
        if (!card) return;

        var isActive = card.classList.toggle(CLASSES.ownItActive);
        var video = card.querySelector(SELECTORS.ownItVideo);

        if (video) {
          if (isActive) {
            video.play().catch(function () {});
          } else {
            // Najpierw animacja clip-path (0.6s), potem stop wideo
            setTimeout(function () {
              video.pause();
              video.currentTime = 0;
            }, 600);
          }
        }
      });
    });

    // Zapobiegaj propagacji kliku z CTA buttona do karty
    var ctas = document.querySelectorAll('.own-it-cta');
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================
  function init() {
    initFlipCards();
    initVideoAutoplay();
    initCardVisibility();
    initOwnItSwitch();
  }

  // Uruchom po załadowaniu DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
